import React, { memo, useEffect, useState } from 'react';
import EmailInputAndDropFile from './email-verifier-input-and-file-upload';
import GlobalRestrictionModal from '../home/components/global-restriction-modal';
import { EmailVerifierProps } from './types';
import { redirectWithoutRefresh } from '../../shared/utils';

const EmailVerifier: React.FC<EmailVerifierProps> = memo(
  ({ isDemoAccount }) => {
    const [
      showGlobalRestrictionModal,
      setShowGlobalRestrictionModal,
    ] = useState(false);

    useEffect(() => {
      if (isDemoAccount) {
        setShowGlobalRestrictionModal(true);
      }
    }, [isDemoAccount]);

    return (
      <div className="email-verifier-container">
        <EmailInputAndDropFile />
        <GlobalRestrictionModal
          show={showGlobalRestrictionModal}
          onClose={() => redirectWithoutRefresh('/sequence')}
          title="Email Verification tab is disabled in demo mode"
          content="This is a demo account with sample data. Signup to verify email addresses and start verifying the email"
        />
      </div>
    );
  },
);

export default EmailVerifier;
